module.exports = __webpack_public_path__ + "84e92848cda179cbcfa8ca5e6e0c32d2.pdf";